export default {
  systemName: '浜松市防災情報システム',
  systemIcon: require('@/assets/logo.svg'),
};
